module.exports = __webpack_public_path__ + "static/insurance-hero-mobile.0e1054e0.webp";